import * as cartConstants from '../cartConstants';
import * as metaStateUtils from '../../../../store/util/metaStateUtils';

import cartSubmittedReducer from './cartSubmittedReducer';
import removeCartItemsReducer from './removeCartItemsReducer';
import saveCartReducer from './saveCartReducer';
import saveCartsReducer from './saveCartsReducer';
import saveCartHeaderUpdate from './saveCartHeaderUpdate';


const INITIAL_STATE = metaStateUtils.withDefaultMetaState({
    carts: {}
});


export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case cartConstants.ACTION_CART_LOADED:

            return saveCartReducer(state, action.payload);


        case cartConstants.ACTION_CARTS_LOADED:

            return saveCartsReducer(state, action.payload);


        case cartConstants.ACTION_CARTS_LOADING:

            return metaStateUtils.setIsLoading(state);


        case cartConstants.ACTION_CART_HEADER_UPDATED:

            return saveCartHeaderUpdate(state, action.payload);


        case cartConstants.ACTION_CART_ITEMS_REMOVED:

            return removeCartItemsReducer(state, action.payload);


        case cartConstants.ACTION_CART_SUBMITTED:

            return cartSubmittedReducer(state, action.payload);


        default:

            return state;
    }
};
